import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=1813d1dc&scoped=true&"
import script from "./FieldSelector.vue?vue&type=script&lang=js&"
export * from "./FieldSelector.vue?vue&type=script&lang=js&"
import style0 from "./FieldSelector.vue?vue&type=style&index=0&id=1813d1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813d1dc",
  null
  
)

export default component.exports